import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-sort3-icon',
  templateUrl: './shopping-sort3.component.html'
})
export class ShoppingSort3Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
